module.exports = __webpack_public_path__ + "img/netlify-logo.0e6a1002.svg";